<template>
  <el-form>
    <el-form-item label="名称">
      <el-input v-model="data.name"></el-input>
    </el-form-item>
    <el-form-item>
      <el-checkbox v-model="data.dynamicHeight">由内容撑开高度</el-checkbox>
    </el-form-item>
    <el-form-item label="内边距(padding)">
      <el-input v-model="data.padding"></el-input>
    </el-form-item>
    <el-form-item label="样式类名(class)">
      <el-input v-model="data.className"></el-input>
    </el-form-item>
    <el-form-item label="样式(style)">
      <el-input v-model="data.style"></el-input>
    </el-form-item>

    <el-button-group>
      <el-button type="primary" icon="fa fa-add" @click="addColumn">增加</el-button>
      <el-button type="primary" icon="fa fa-delete" @click="deleteColumn">删除</el-button>
    </el-button-group>
    <el-table
      ref="table"
      :data="data.columns"
      style="width: 100%">
      <el-table-column
        type="selection"
        width="23">
      </el-table-column>

      <el-table-column
        label="宽度"
      >
        <template slot-scope="scope">
          <el-input v-model="scope.row.width"></el-input>
        </template>
      </el-table-column>
      <el-table-column
        label="左边距"
        width="62"
      >
        <template slot-scope="scope">
          <el-input v-model="scope.row.paddingLeft"></el-input>
        </template>
      </el-table-column>
      <el-table-column
        label="右边距"
        width="62"
      >
        <template slot-scope="scope">
          <el-input v-model="scope.row.paddingRight"></el-input>
        </template>
      </el-table-column>
      <el-table-column
        label="样式类"
        width="80"
      >
        <template slot-scope="scope">
          <el-input v-model="scope.row.className"></el-input>
        </template>
      </el-table-column>
      <el-table-column
        label="样式"
        width="200"
      >
        <template slot-scope="scope">
          <el-input v-model="scope.row.style"></el-input>
        </template>
      </el-table-column>
    </el-table>
  </el-form>
</template>

<script>
  export default {
    name:"hbox-editor",
    props:["data","params"],
    methods:{
      addColumn(){
        this.data.columns.push({
          width:""
        });
      },
      deleteColumn(){
        let selection=this.$refs.table.selection;
        if(!selection)return;
        this.data.columns=this.data.columns.filter(c=>selection.indexOf(c)===-1);
      }
    }
  }
</script>

<style scoped>
  .el-form >>> .el-form-item{
    margin-bottom: 0 !important;
  }
</style>



// WEBPACK FOOTER //
// src/common/components/extend/layout/designer/hbox-editor.vue